import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

import { ModelBase } from 'store/model-base';
import { ApiChannel } from 'core/constants';
import { buildHeaders, XmStore } from 'core/services';
import { CreditCard } from './models';
import { StoreAction } from 'store/actions';

@Injectable()
export class CreditCardApi {
    public static getCreditCardInfo(_xmStore: XmStore, http: HttpClient): Observable<CreditCard> {
        return http.get('/account/paymentinstrument', {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((response: CreditCard) => CreditCard.create<CreditCard>(response))
        );
    }

    public static postCreditCardInfo(xmStore: XmStore, http: HttpClient, payload: ApiParams): Observable<CreditCard> {
        return http.post('/account/paymentinstrument', payload, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            mergeMap(() => xmStore.query<CreditCard>(StoreAction.GET_CREDIT_CARD, CreditCard)) // temp fix until new api is available
        );
    }
}

ModelBase.fetchMapping[StoreAction.GET_CREDIT_CARD] = CreditCardApi.getCreditCardInfo;
ModelBase.persistMapping[StoreAction.POST_CREDIT_CARD] = CreditCardApi.postCreditCardInfo;
